const map = {
	"./Webinar_1_Concussions_And_Worker_2026/event-sponsor-images/ARC_PT-logo.jpg": 328,
	"./Webinar_2_Modern_Investigations_2027/event-sponsor-images/SSM_Health-Logo.png": 500,
	"./Webinar_3_Common_Mistakes_2027/event-sponsor-images/AT.png": 54,
	"./Webinar_3_Common_Mistakes_2027/event-sponsor-images/ATGS-Logo.png": 890,
	"./Webinar_4_Breaking_The_Pain_2027/event-sponsor-images/ARC_PT-logo.jpg": 264,
	"./Webinar_5_Private_Vocational_Rehabilitation_2027/event-sponsor-images/evansdixon_logo.png": 687,
	"./events": 565,
	"./events.json": 565,
	"./lunchNLearn_2026-11-18/November-Lunch-N-Learn.pdf": 209,
	"./midRiversRiskForum_2026/Mid-Rivers-Risk-Forum-2026-flyer.pdf": 342
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 995;